"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function Livestreams(_a) {
    var livestreams = _a.livestreams;
    var cols = livestreams.length <= 2 ? 2 : livestreams.length;
    return react_1.default.createElement(storybook_1.Layouts.Container, { className: 'storybook-channels-livestreams storybook-layouts-space' },
        react_1.default.createElement("div", { className: 'storybook-channels-livestreams-cards' },
            react_1.default.createElement(storybook_1.Videos.Cards, { className: "col-span-" + cols }, livestreams.map(function (video, index) {
                return react_1.default.createElement(storybook_1.Videos.CardLive, { key: index, video: video });
            }))));
}
exports.default = Livestreams;
